import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
 * DO NOT EDIT THIS FILE DIRECTLY
 *
 * It is automatically generated using yarn run icons:generate.
 */

import * as React from 'react';
import IconFiletypePdf16 from "./IconFiletypePdf16";
import IconFiletypePdf24 from "./IconFiletypePdf24";
var icons = {
  16: IconFiletypePdf16,
  24: IconFiletypePdf24
}; // prettier-ignore

export var IconFiletypePdf = React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      other = _objectWithoutProperties(_ref, ["size"]);

  var Icon = icons[size];
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, other));
});